"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRevisionSchemaVersion = getRevisionSchemaVersion;
exports.isRevisionSchemaV2 = isRevisionSchemaV2;
const revision_constants_js_1 = require("./revision.constants.js");
/** Missing schemaVersion is v1. Never infer v2 from payload shape. */
function getRevisionSchemaVersion(input) {
    if (input?.schemaVersion === revision_constants_js_1.REVISION_SCHEMA_V2)
        return revision_constants_js_1.REVISION_SCHEMA_V2;
    if (input?.schemaVersion === revision_constants_js_1.REVISION_SCHEMA_V1)
        return revision_constants_js_1.REVISION_SCHEMA_V1;
    if (input?.metadata?.schemaVersion === revision_constants_js_1.REVISION_SCHEMA_V2)
        return revision_constants_js_1.REVISION_SCHEMA_V2;
    if (input?.metadata?.schemaVersion === revision_constants_js_1.REVISION_SCHEMA_V1)
        return revision_constants_js_1.REVISION_SCHEMA_V1;
    return revision_constants_js_1.REVISION_SCHEMA_V1;
}
function isRevisionSchemaV2(input) {
    return getRevisionSchemaVersion(input) === revision_constants_js_1.REVISION_SCHEMA_V2;
}
